/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_RightInputs */



/**
* | output |
* | --- |
* | "Right (%)" |
*
* @param {Ocr_Crop_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_right = /** @type {((inputs?: Ocr_Crop_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Droite (%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechts (%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giusto (%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Верно (%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bien (%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正确的 （％）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右 （％）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सही (%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Certo (%)")
	return /** @type {LocalizedString} */ ("Right (%)")
});